export class PageQuery {
    public page = 1;
    public pageSize = 10;
    public rowCount: number;
}
